import {Card, Stack} from '@mui/material';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {AppointmentAddress} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentAddress';
import {AppointmentInfoList} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentInfoList';
import React from 'react';
import {OdontoConfirmBookingButton} from '../OdontoReviewBooking/components/OdontoConfirmBookingButton';
import {useOdontoReviewBookingNew} from './hooks/useOdontoReviewBookingNew';
import {StyledContainer} from './styles';
import {OdontoReviewBookingNewProps} from './types';

export function OdontoReviewBookingNew({handlePrevStep}: OdontoReviewBookingNewProps) {
	const {
		beneficiaryName,
		planName,
		providerName,
		specialtyName,
		clinicName,
		date,
		hour,
		formattedAddress,
		addressForMaps,
		handleOpenGoogleMaps,
	} = useOdontoReviewBookingNew();

	return (
		<StyledContainer>
			<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
				<Stack gap={3}>
					<AppointmentInfoList
						beneficiaryName={beneficiaryName}
						planName={planName}
						providerName={providerName}
						specialtyName={specialtyName}
						clinicName={clinicName}
						date={date}
						hour={hour}
						flowType={FlowEnum.ODONTO}
					/>
					<AppointmentAddress
						formattedAddress={formattedAddress}
						addressForMaps={addressForMaps}
						handleOpenMap={handleOpenGoogleMaps}
					/>
				</Stack>
			</Card>
			<OdontoConfirmBookingButton handleBack={handlePrevStep} />
		</StyledContainer>
	);
}
